import bgImageMX from "../../../assets/background-seleccion.jpg";

const POSITIONS_ORDER = ["Portero", "Defensa", "Medio", "Delantero"];

const styles = {
  root: {
    width: "1080px",
    height: "1920px",
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  body: {
    position: "absolute",
    top: "320px",
    right: "35px",
    width: "370px",
    display: "flex",
    flexDirection: "column",
    gap: "0px",
  },
  group: {
    padding: "12px 20px",
  },
  playerList: {
    listStyle: "none",
    margin: "0",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  playerItem: {
    color: "var(--color-white)",
    fontSize: "30px",
    textTransform: "uppercase",
    fontFamily: "Arial, sans-serif",
    letterSpacing: "0px",
    wordSpacing: "0px",
    whiteSpace: "nowrap",
    lineHeight: "1.3",
  },
};

export default function ShareImageSelection({ selectedPlayers, config }) {
  const shareImage = config?.shareImage || bgImageMX;
  const accentColor = config?.selectedColor || "#e1241b";
  const textColor = config?.shareTextColor || "#ffffff";

  const byPosition = POSITIONS_ORDER.reduce((acc, pos) => {
    acc[pos] = selectedPlayers.filter((p) => p.posicion === pos);
    return acc;
  }, {});

  const groupTitleStyle = {
    fontSize: "40px",
    fontWeight: "700",
    color: `${textColor}`,
    textTransform: "uppercase",
    margin: "0 0 18px 0",
    borderBottom: `3px solid ${accentColor}`,
    paddingBottom: "6px",
    fontFamily: "Arial, sans-serif",
    letterSpacing: "0px",
    wordSpacing: "0px",
  };

  return (
    <div aria-hidden="true" style={{ ...styles.root, backgroundImage: `url(${shareImage})` }}>
      <div style={styles.body}>
        {POSITIONS_ORDER.map((pos) => (
          byPosition[pos].length > 0 && (
            <div key={pos} style={styles.group}>
              <h3 style={groupTitleStyle}>{pos}s</h3>
              <ul style={styles.playerList}>
                {byPosition[pos].map((player) => (
                  <li key={player.index} style={{ ...styles.playerItem, color: textColor }}>
                    {player.nombre}
                  </li>
                ))}
              </ul>
            </div>
          )
        ))}
      </div>
    </div>
  );
}